import { useTheme } from '@vebox/etui-system';
import { createElement } from 'react';
import { b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Label as Label$1 } from '@vebox/etui-system-elements';

function Label(props) {
  const theme = useTheme();
  return /*#__PURE__*/createElement(Label$1, _extends({
    color: theme.palette.text.secondary
  }, theme.typography.label, props));
}

export default Label;
